import styled from "styled-components";

export const Container = styled.header`
  width: 100%;
  padding: 16px 28px;
  display: flex;
  align-self: center;
  justify-content: space-between;
  background-color: transparent;
  flex-wrap: wrap;
  gap: 16px;

  .form__input_search-header {
    border-radius: 30px;
    background-color: ${(props) => props.theme.colors.primary};
    border: 3px solid ${(props) => props.theme.colors.primary};

    > input {
      border-radius: 30px;
      padding-right: 20px;
    }

    > button {
      border-radius: 50%;
      position: relative;
      padding: 0px;

      ::before {
        content: url("data:image/svg+xml,%3Csvg fill='%23000000' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='20px' height='20px'%3E%3Cpath d='M 19 3 C 13.488281 3 9 7.488281 9 13 C 9 15.394531 9.839844 17.589844 11.25 19.3125 L 3.28125 27.28125 L 4.71875 28.71875 L 12.6875 20.75 C 14.410156 22.160156 16.605469 23 19 23 C 24.511719 23 29 18.511719 29 13 C 29 7.488281 24.511719 3 19 3 Z M 19 5 C 23.429688 5 27 8.570313 27 13 C 27 17.429688 23.429688 21 19 21 C 14.570313 21 11 17.429688 11 13 C 11 8.570313 14.570313 5 19 5 Z'/%3E%3C/svg%3E");
        position: absolute;
        width: 35px;
        height: 100%;
        background-color: ${(props) => props.theme.colors.primary};
        border-radius: 50%;
        top: 0;
        left: -33px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;

export const Logo = styled.h1`
  > a {
    color: ${(props) => props.theme.colors.primary};
    > span {
      color: ${(props) => props.theme.colors.secondary};
    }
  }
`;
